module.exports = __webpack_public_path__ + "img/settlement.53f1c079.svg";